// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OVUhVbPuUkUIDjRxcuCg {
  background-color: black;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.OVUhVbPuUkUIDjRxcuCg > div {
  background-color: red;
  width: 1280px;
  height: 640px;
  position: relative;
}
.OVUhVbPuUkUIDjRxcuCg > div > * {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/GameFrame.sass"],"names":[],"mappings":"AACA;EACC,uBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAD;AACC;EACC,qBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AACF;AAAE;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAEH","sourcesContent":["\n.gameFrame\n\tbackground-color: black\n\twidth: 100%\n\theight: 100vh\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: center\n\t> div\n\t\tbackground-color: red\n\t\twidth: 1280px\n\t\theight: 640px\n\t\tposition: relative\n\t\t> *\n\t\t\tposition: absolute\n\t\t\ttop: 0\n\t\t\tleft: 0\n\t\t\tbottom: 0\n\t\t\tright: 0\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameFrame": `OVUhVbPuUkUIDjRxcuCg`
};
export default ___CSS_LOADER_EXPORT___;
